/**
 * 历史记录类型
 */
export enum HistoryType {
    SEEK_SEARCH = 'SEEK_SEARCH',
    TECH_MIND = 'TECH_MIND',
    TECH_RESEARCH = 'TECH_RESEARCH',
    TECH_FMEA = 'TECH_FMEA',
    /**
     * 旧的白板历史记录类型
     */
    IDEA_EXPLORATION = 'IDEA_EXPLORATION'
}

/**
 * 菜单类型
 */
export enum MenuPath {
    /**
     * 首页
     */
    AIR = 'air',
    /**
     * 工具
     */
    TOOLS = 'tools',
    TECKMIND = 'whiteboard',
    TECHRESEARCH = 'project',
    TECHRISK = 'fmea',
    EXPLORE = 'explore',
    HISTORY = 'history',
    NEWSLETTER = 'newsletter',
    /**
     * newsletter 所有订阅列表
     */
    NEWSLETTER_TOPIC = 'topics',
    /**
     * newsletter 我的订阅列表
     */
    NEWSLETTER_SUBSCRIPTION = 'mySubscription',
    MYMONITOR = 'myMonitor',
    INCOGNITO = 'incognito',
    DETAIL = 'detail'
}
export interface HistoryItem {
    id: string;
    title: string
    type: HistoryType,
    created_at: string,
    active?: boolean,
}

export interface GetNavListResponse {
    limit: number,
    page: number,
    records: HistoryItem[],
}

export enum NavTheme {
    DARK = 'dark',
    LIGHT = 'light'
}

export enum NavSection {
    DEFAULT = 'DEFAULT',
    HEADER = 'HEADER',
    FOOTER = 'FOOTER'
}

export interface NavMenuItem {
    id: string;
    title: string;
    icon?: string;
    children?: NavMenuItem[];
    active?: boolean;
    expand?: boolean;
    onClick?: () => void;
}
